(function() {
  function updateBadge(quantity) {
    const badges = document.querySelectorAll('.low-stock-overlay, .low-stock-badge');
    badges.forEach(badge => {
      if (quantity >= 1 && quantity <= 4) {
        
      
        badge.style.display = 'none';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function fetchInventory() {
    const variantId = document.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    fetch('/variants/' + variantId + '.js')
      .then(res => res.json())
      .then(data => updateBadge(data.inventory_quantity))
      .catch(() => {});
  }

  fetchInventory();

  document.addEventListener('cart:updated', fetchInventory);
  document.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      setTimeout(fetchInventory, 300);
    }
  });
})();